export const environment = {
  version: 0,
  APIBaseUrl: 'https://uat-services.pickright.co.in',
  token: 'marsAdminToken',
  routePrefix: 'portfolio-advisory'
};